<script setup>
import resolveLayouts from '@/project/layouts/resolveLayouts'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const layouts = computed(() => {
  return resolveLayouts(route)
})
</script>

<template>
  <component :is="layouts?.wrapper || 'div'">
    <component :is="layouts?.layout || 'div'">
      <router-view></router-view>
    </component>
  </component>
</template>
